export default __webpack_public_path__ + "static/media/OUTSTANDINGPAYMENT_SAVE2.856130c8.png";